import { Text, View } from "react-native";
import { Link, Slot, Stack, useLocalSearchParams } from "expo-router";

import { useAccountActions } from "~/components/AccountActions/context";
import { PageMeta } from "~/components/PageMeta";
import { ResponsiveRenderer } from "~/components/ResponsiveRenderer";
import {
  WorkspaceActions,
  WorkspaceMenu,
} from "~/components/Workspace/WorkspaceMenu";
import { useCurrentSpace } from "~/hooks/useCurrentSpace";
import { useAccountStore } from "~/stores/space";
import { ListContainer, ListContainerTitleText, ListItem } from "~/ui/List";

// export const unstable_settings = {
//   initialRouteName: "index",
// };
export default function SpaceLayout() {
  const localParams = useLocalSearchParams<{
    account: string;
    space: string;
  }>();
  try {
    const { space } = useCurrentSpace();
    return (
      <>
        <Stack.Screen options={{ headerShown: false }} />
        <PageMeta title={space.displayName ?? space.slug} />
        <ResponsiveRenderer
          webDesktop={
            <View className="max-h-full grow web:grid web:grid-cols-[auto_1fr]">
              <View
                className={
                  "group/sidebar border-divider-strong overflow-auto border-r px-2 py-2"
                }
                style={{
                  width: 300,
                }}
              >
                <View className="flex-row justify-between px-2 py-5">
                  <Text className="text-xl font-semibold text-white">
                    {space.displayName}
                  </Text>
                  <WorkspaceActions />
                </View>
                <WorkspaceMenu />
              </View>
              <Slot />
            </View>
          }
          default={
            <Stack screenOptions={{}}>
              <Stack.Screen
                name="imagePreview"
                options={{
                  animation: "default",
                  presentation: "modal",
                  title: "Image Preview",
                }}
              />
            </Stack>
          }
        />
      </>
    );
  } catch (e) {
    return (
      <>
        <Stack.Screen options={{ headerTitle: "" }} />
        <View className="items-center justify-center">
          <Text className="text-text-primary text-2xl">
            Workspace {localParams.space} not found or not accessible.
          </Text>
          <Link
            href={{
              pathname: "/(app)/(authenticated)/[account]/(account)",
              params: { account: localParams.account },
            }}
          >
            <Text className="text-text-primary">Return to account home</Text>
          </Link>
        </View>
      </>
    );
  }
}
